import { CUSTOM_ATTRIBUTE_VALUE_PATTERN, LIQUID_STRING_LITERAL_FORBIDDEN_CHARACTERS } from '~/utils/validation';

export const FALLBACK_KEY_CONTACT_FIRST_NAME = 'contact.first_name';
export const FALLBACK_KEY_CONTACT_LAST_NAME = 'contact.last_name';
export const FALLBACK_KEY_CONTACT_EMAIL = 'contact.email';
export const FALLBACK_KEY_CONTACT_ENTRY_CHANNEL = 'contact.entry_channel';
export const FALLBACK_KEY_CONTACT_MEMBERSHIP_STATUS = 'contact.membership_status';
export const FALLBACK_KEY_CONTACT_LIFECYCLE_STATUS = 'contact.lifecycle_status';
export const FALLBACK_KEY_GROUP_NAME = 'group.name';

export const CONTACT_CUSTOM_ATTRIBUTE_FALLBACK_PREFIX = 'contact.custom_attributes.';
export const GROUP_CUSTOM_ATTRIBUTE_FALLBACK_PREFIX = 'group.custom_attributes.';

export const MAX_FALLBACK_VALUE_LENGTH = 350;
export const MAX_FALLBACKS_PER_TEAM = 500;

export type MessageVariableFallbackMap = Record<string, string>;

// Mirrors MessageTemplateExpander, which resolves contact custom attribute tokens by the sanitized key.
export const sanitizeContactCustomAttributeKey = (key: string): string => key.replace(/[^A-Za-z0-9]/g, '_');

export const contactCustomAttributeFallbackKey = (rawKey: string): string =>
    `${CONTACT_CUSTOM_ATTRIBUTE_FALLBACK_PREFIX}${rawKey}`;

export const groupCustomAttributeFallbackKey = (rawKey: string): string =>
    `${GROUP_CUSTOM_ATTRIBUTE_FALLBACK_PREFIX}${rawKey}`;

// The Liquid engine has no escape syntax inside a quoted literal, so a value is embedded verbatim or not at all;
// the check mirrors the rules the server applies on save.
export const isSafeFallbackValue = (value: string): boolean =>
    value.trim() !== '' &&
    value.length <= MAX_FALLBACK_VALUE_LENGTH &&
    CUSTOM_ATTRIBUTE_VALUE_PATTERN.test(value) &&
    !LIQUID_STRING_LITERAL_FORBIDDEN_CHARACTERS.some((character) => value.includes(character));

// The unique key on the server ignores case, so lookups and duplicate checks do too.
export const normalizeFallbackKey = (key: string): string => key.toLowerCase();

const VARIABLE_TOKEN_PATTERN = /^\{\{\s*(.+?)\s*\}\}$/;

export const buildVariableToken = (variable: string, fallback?: string): string => {
    const match = VARIABLE_TOKEN_PATTERN.exec(variable);

    if (!match || fallback === undefined || !isSafeFallbackValue(fallback)) {
        return variable;
    }

    return `{{ ${match[1]} | default: '${fallback}' }}`;
};
